<script lang="ts">
  import { tick } from 'svelte';
  import NewsletterSubscriptionFullWidth from './NewsletterSubscriptionFullWidth.svelte';
  import NewsletterSubscriptionInline from './NewsletterSubscriptionInline.svelte';
  import { browser } from '$app/environment';
  import { PUBLIC_SWEAT_API_URL } from '$env/static/public';

  export let newsletterSubscriptionProps: {
    title: string;
    description: string;
    width: boolean;
  };
  let isSubmitted = false;
  let errorMessage = '';
  let checkboxError = false;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  function resetFormValidation() {
    isSubmitted = false;
    errorMessage = '';
    checkboxError = false;
  }

  async function handleSubmit(e) {
    resetFormValidation();
    await tick();
    const email = e.target[0].value;
    const checkbox = e.target[1].checked;

    // Email Validation
    if (!email || !emailRegex.test(email)) {
      errorMessage = 'Please enter a valid email';
    }

    // Checkbox Validation
    if (!checkbox) {
      checkboxError = true;
    }

    if (errorMessage || checkboxError) return;
    isSubmitted = true;

    if (browser) {
      // Send the details to our API:
      const postData = new FormData();
      postData.append('email', email);
      postData.append('signup_source', 'sweat.com');
      postData.append('account', 'sweat');
      postData.append('locale', 'en');

      const response = await fetch(`${PUBLIC_SWEAT_API_URL}/api/v8/email-list-subscriber`, {
        method: 'POST',
        body: postData,
      });

      if (!response.ok) {
        // The 'success' variable is set early, so we get a flash of "That worked" before the error message is set
        errorMessage = 'Something went wrong. Please try again later.';
      }
    }
  }
</script>

{#if newsletterSubscriptionProps?.width}
  <NewsletterSubscriptionFullWidth
    {...newsletterSubscriptionProps}
    {isSubmitted}
    {errorMessage}
    {checkboxError}
    {handleSubmit}
  />
{:else}
  <NewsletterSubscriptionInline
    {...newsletterSubscriptionProps}
    {isSubmitted}
    {errorMessage}
    {checkboxError}
    {handleSubmit}
  />
{/if}
